import { RefreshCw } from 'lucide-react';
import { useAppVersion } from '@/hooks/useAppVersion';

export function UpdateAvailablePrompt() {
  const { updateAvailable, applyUpdate } = useAppVersion();

  if (!updateAvailable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-in slide-in-from-bottom-2 fade-in duration-300">
      <div className="bg-card border border-border rounded-2xl shadow-lg p-4 flex items-center gap-3 max-w-sm">
        <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
          <RefreshCw className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground">Update Available</p>
          <p className="text-xs text-muted-foreground">A new version is ready</p>
        </div>
        <button
          onClick={applyUpdate}
          className="flex-shrink-0 px-3 py-1.5 bg-primary text-primary-foreground text-sm font-medium rounded-xl hover:bg-primary/90 transition-colors"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
